import * as ax from "../instrance";
import config from "../../../config/config.js";
var URL = config.apiUrl;


//标签列表信息
export const getBqList = params => {
  return ax.g(URL + "/jeecg-boot/test/portal/list", params);
};



// WEBPACK FOOTER //
// ./src/api/test-api/test.js